// extracted by mini-css-extract-plugin
export default {"container":"sections_container__S8OSg","sectionDevider":"sections_sectionDevider__89U0y","sectionItems":"sections_sectionItems__GUyBk","sectionItem":"sections_sectionItem__L8Dp3"};